import { render } from "./navigationButtons.vue?vue&type=template&id=6bb99f2f"
import script from "./navigationButtons.vue?vue&type=script&lang=js"
export * from "./navigationButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__